import React, { useEffect, useState, useRef } from "react";
import { object, bool } from "prop-types";
import { get } from "lodash";
import { useDeviceType } from "../../../components/customHooks/useDeviceType";
import { useSelector } from "react-redux";

import "./most-valued-celeb.m.css";
import { Link } from "@quintype/components";

const CELEBRITIES_API_FALLBACK = [
  "https://s3.ap-south-1.amazonaws.com/static.fortuneindia.com",
  "most-valuable-celebrities/2026-most-valuable-celebrities.json",
].join("/");

export const MostValuedCelebrities = ({ collection, storyPage = false }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const entityData = storyPage ? collection : collection?.entityData;
  const [entityDetails, setEntityDetails] = useState([]);
  const [isInView, setIsInView] = useState(false);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const celebritiesApiUrl = get(
    qtState,
    ["config", "publisher-attributes", "most-valuable-celebrities-api-url"],
    CELEBRITIES_API_FALLBACK
  );

  const ref = useRef();

  const {
    name = "India's Most Valuable Celebrities",
    buttonText = "View full list",
    buttonLink = "/rankings/indias-most-valuable-celebrities/2026",
    year = "2026",
    showRanking = true,
  } = entityData || {};

  useEffect(() => {
    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.disconnect();
      }
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isInView) return;

    const fetchData = async () => {
      try {
        const response = await fetch(celebritiesApiUrl);
        if (!response.ok) throw new Error(`Failed to fetch celebrities data: ${response.status}`);
        const data = await response.json();
        setEntityDetails((data?.snapshots || []).slice(0, 4));
      } catch (err) {
        console.error("Failed to fetch entity details", err);
        setEntityDetails([]);
      }
    };

    fetchData();
  }, [celebritiesApiUrl, isInView]);

  const handleWidgetClick = () => {
      if (isTracking) return;
      isTracking = true;

      setTimeout(() => {
        isTracking = false;
      }, 300);

      if (typeof window !== "undefined" && window.dataLayer) {
        const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);
        window.dataLayer.push({
          event: "dl_ranking_widget_click",
          link_text: buttonText.toLowerCase(),
          link_position: "-1",
          link_category: linkCategory?.toLowerCase(),
          category,
          sub_category: subCategory,
          content_id: contentId,
          template_name: getTemplateName(story?.["story-template"] || pageType),
          platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        });
      }
    };

  if (!entityDetails.length) return <div ref={ref} />;

  return (
    <div ref={ref} styleName="celebrities-widget">
      <div className="container" styleName="celebrities-container">
        <div styleName="celebrities-header">
          <div styleName="title">
            <img {...(storyPage ? { loading: "lazy" } : {})} styleName="header-logo" src="https://media.fortuneindia.com/fortune-india/2026-06-15/7k3b7db7/top-celebrities.png" width="70" height="70" title="logo" alt="logo" />
            <h3>{name}{' '}{year}</h3>
          </div>
          {isDesktop && buttonText && buttonLink && (
            <a href={buttonLink} styleName="view-link">
              {buttonText}
            </a>
          )}
        </div>
        <div styleName="celebrities-grid">
          {entityDetails.map((celebrity) => (
            <a href={buttonLink} styleName="celebrity-card" key={`${celebrity?.rank}-${celebrity?.brand}`}>
              <div styleName="celebrity-image">
                <img
                  src={celebrity?.image_link}
                  alt={celebrity?.brand}
                  title={celebrity?.brand}
                  width="261"
                  height="261"
                  loading="lazy"
                />
                {showRanking && celebrity?.rank && <span styleName="rank">{celebrity.rank}</span>}
              </div>
              <div styleName="celebrity-content">
                <h4>{celebrity?.brand}</h4>
                {/* {celebrity?.sector && <span>{celebrity.sector}</span>} */}
                {celebrity?.brand_value_cr && <p>&#8377;{celebrity.brand_value_cr} cr</p>}
              </div>
            </a>
          ))}
        </div>
        {!isDesktop && <Link
        href={buttonLink}
        styleName="link"
        disableAjaxLinks={true}
        onMouseDown={handleWidgetClick}
        onTouchStart={handleWidgetClick}
      >
        <span styleName="link-text">{buttonText}</span>
      </Link>}
      </div>
    </div>
  );
};

MostValuedCelebrities.propTypes = {
  collection: object,
  storyPage: bool,
};

// export default MostValuedCelebrities;
